export class RebateCriteriaTypeDto {
  id: number;
  name: string;
}